import { useState } from "react";
import { MAX_BASE, MIN_WAGE, TAX_RATE, Euro, eur, fmt, Toggle, Field, Note, InputCard, ResultCard } from "./shared";
import { useLang } from "@/lib/i18n";

const NPR = 0.25;
const EMP_RATE = 0.1198;
const ER_RATE = 0.1582;

export const CivilContractCalc = () => {
  const [insured, setInsured] = useState("yes");
  const [amount, setAmount] = useState("1000");
  const { t } = useLang();
  const s = t.calc.civil;
  const gross = parseFloat(amount.replace(",", ".")) || 0;

  const npr = gross * NPR;
  const taxable = gross - npr;
  const insuranceDue = insured === "yes" && taxable >= MIN_WAGE;
  const base = insuranceDue ? Math.min(taxable, MAX_BASE) : 0;
  const empIns = base * EMP_RATE;
  const erIns = base * ER_RATE;
  const tax = Math.max(taxable - empIns, 0) * TAX_RATE;
  const net = gross - empIns - tax;

  const rows = [
    { label: s.rows.npr, ...eur(npr), testid: "civil-row-npr" },
    { label: s.rows.emp, ...eur(empIns), testid: "civil-row-emp-insurance" },
    { label: s.rows.tax, ...eur(tax), testid: "civil-row-tax" },
    { label: s.rows.er, ...eur(erIns), testid: "civil-row-er-insurance" },
    { label: s.rows.total, ...eur(gross + erIns), testid: "civil-row-total-cost" },
  ];

  const note = insuranceDue ? s.noteDue : insured === "yes" ? s.noteBelow(MIN_WAGE.toFixed(2).replace(".", ",")) : s.noteElsewhere;

  return (
    <>
      <InputCard kicker={s.kicker}>
        <Toggle
          testidPrefix="civil-insured"
          value={insured}
          onChange={setInsured}
          options={[
            { id: "yes", label: s.yes },
            { id: "no", label: s.no },
          ]}
        />
        <Field id="civil-amount" testid="civil-amount-input" label={s.amount} value={amount} onChange={setAmount} />
        <Note>{note}</Note>
      </InputCard>
      <ResultCard title={s.title} service={s.service} note={note} label={s.result} main={<Euro value={net} />} mainText={`${fmt(net)} €`} rows={rows} />
    </>
  );
};
